module.exports = __webpack_public_path__ + "img/building95.48d7b287.jpg";